import { Button, Card } from '@helix-ds/react'
import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import SupportRequestModal from './SupportRequestModal'

const SupportCard: React.FC = () => {
  const [supportModalOpen, setSupportModalOpen] = useState(false)

  return (
    <Card className="min-h-[152px]">
      <div className="flex flex-col items-end gap-4">
        <h2 className="text-text-heading self-stretch text-base font-semibold">
          <FormattedMessage id="home.support.heading" defaultMessage="We are here to help" />
        </h2>
        <p className="text-text-body self-stretch text-sm leading-6">
          <FormattedMessage
            id="home.support.body"
            defaultMessage="Reach out with any question about your results, consents, scheduling, or your account. A member of our care team will follow up with you."
          />
        </p>
        <Button type="button" variant="secondary" onClick={() => setSupportModalOpen(true)}>
          <FormattedMessage id="home.support.contactButton" defaultMessage="Contact support" />
        </Button>
      </div>
      <SupportRequestModal isOpen={supportModalOpen} onClose={() => setSupportModalOpen(false)} />
    </Card>
  )
}

export default SupportCard
